document.addEventListener("DOMContentLoaded", function () {
  console.log("Script chargé");

  setTimeout(function () {
    // Détecter la langue depuis l'URL
    const currentLang =
      window.location.pathname.startsWith("/en/") ||
      window.location.pathname === "/en"
        ? "en"
        : "fr";
    console.log("Langue détectée:", currentLang);

    // Chercher tous les labels
    const allLabels = document.querySelectorAll("label");
    console.log("Tous les labels:", allLabels.length);

    allLabels.forEach((label, index) => {
      if (label.textContent.includes("échantillons")) {
        console.log(`Label trouvé avec "échantillons":`, label);

        if (currentLang === "en") {
          label.textContent = "Select 5 samples:";
          console.log("Texte changé en anglais");
        }
      }
    });
  }, 1000);
});
